import axios from "axios";
import { API_URL } from "../config";
import { user } from "./actions_helper";

export type ReportKind = "open_invoices" | "maintenance_invoices";

export interface IReportTriggerResponse {
    status: string;
    report: ReportKind;
    month: string | null;
    recipients: string[];
}

export async function triggerReportMail(
    report: ReportKind,
    options: { month?: string } = {}
): Promise<IReportTriggerResponse> {
    const response = await axios.post(
        `${API_URL}/reports/${report}.json`,
        options.month ? { month: options.month } : {},
        { headers: { authorization: user().token } }
    );
    return response.data;
}
